export const CommonActionTypes = {
  DEFAULT: 'COMMON_DEFAULT',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  CLEAR_ALL_NOTIFICATIONS: 'CLEAR_ALL_NOTIFICATIONS',
  CLEAR_REDIRECT: 'CLEAR_REDIRECT',
  SET_LOADING: 'SET_LOADING',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  SET_REDIRECT: 'SET_REDIRECT',
  SET_SERVER_TIME: 'SET_SERVER_TIME',
  REQUEST_SERVER_TIME: 'REQUEST_SERVER_TIME',
  SET_SERVER_TIME_LOADING: 'SET_SERVER_TIME_LOADING',
  SET_TOGGLES: 'SET_TOGGLES',
  SET_SHOULD_RENDER_AI_GUIDE: 'SET_SHOULD_RENDER_AI_GUIDE',
  REQUEST_PDF_URL_BY_TYPE: 'REQUEST_PDF_URL_BY_TYPE',
  SET_PDF_URL: 'SET_PDF_URL',
  GET_PROMPT_FROM_ID: 'GET_PROMPT_FROM_ID',
  SET_AI_CHAT_GET_PROMPTS_LOADING: 'SET_AI_CHAT_GET_PROMPTS_LOADING',
};
